<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Store management</h1>
    <storeManage />
  </v-card>
</template>

<script>
import storeManage from "@/components/back-office/StoreManagement/StoreManageTable.vue";
export default {
  components: {
    storeManage
  },
  destroyed() {
    this.$store.commit("fetchStoreBack/resetStateStoreList");
    this.$store.commit("fetchCustomerBack/resetState");
  },
  async created() {
    //    // this.$store.commit('backOffice/changeLoadingProgress',true)
    //    this.$store.commit('backOffice/changeLoadingProgress',false)
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage"
      },
      {
        text: "Store list",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
